import React from 'react'
import { AccountPlanAdvanceIcon, AccountPlanAdvanceRedIcon, AccuntPlanBasicPlan, AuAccountBasicRedIcon } from '../../assets/images';
type AppProps = {
  title: string;
  features: any;
  originalPrice: string;
  discountedPrice: string;
  isAUCustomer: boolean;
  onSelect?: (planTitle: string) => void;
  isSelected?: boolean;
}
const PlanCard = ({ title, features, originalPrice, discountedPrice, isAUCustomer, onSelect, isSelected }: AppProps) => {
  const handleCardClick = () => {
    if (onSelect) {
      onSelect(title);
    }

  };
  return (
    <>
      <div className={`plan-card ${isSelected ? 'selected-plan' : ''}`} onClick={handleCardClick}>
        <div className="plan-header">
          <div className={` ${isSelected ? 'plan-selected-icon' : 'plan-icon'}`}>

            {title === "Advanced Plan" ?
              <img src={isSelected ? AccountPlanAdvanceRedIcon : AccountPlanAdvanceIcon} alt="planImage" />
              : <img src={isSelected? AuAccountBasicRedIcon:AccuntPlanBasicPlan} alt="planImage" />}
          </div>
          <h6
            // className="plan-title"
            className={`plan-title ${isSelected ? 'plan-selected-title' : ''}`}
          >{title}</h6>
        </div>
        <ul className="plan-features">
          {features.map((feature: any, index: any) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
        <div className="plan-price">
          {originalPrice && <span className="original-price">₹{originalPrice}/-</span>}
          <span className="discounted-price">₹{discountedPrice}/-</span>
        </div>
        {isAUCustomer && <span className="au-customer-only">* For AU Customers Only!</span>}
      </div>

    </>
  )
}

export default PlanCard
